import { c as _c } from "react/compiler-runtime";
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { Logger, trackAction } from '@/idv/utils';
import { useMissingPermissionsSheet } from '../components/missing-permissions-sheet';
const useHandleCameraError = () => {
  const $ = _c(7);
  const {
    toast
  } = useToast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.components.media-errors"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t0);
  const missingPermissionsSheet = useMissingPermissionsSheet();
  let t1;
  if ($[1] !== toast) {
    t1 = description => {
      toast({
        description,
        title: "Uh-oh!",
        variant: "error"
      });
    };
    $[1] = toast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const showErrorToast = t1;
  let t2;
  if ($[3] !== missingPermissionsSheet || $[4] !== showErrorToast || $[5] !== t) {
    t2 = err => {
      const error = err as DOMException;
      if (error instanceof TypeError) {
        showErrorToast(t(_temp));
        trackAction("id-doc:camera-error", {
          cameraError: "undefined-navigator"
        });
      } else {
        if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
          showErrorToast(t(_temp2));
          trackAction("id-doc:camera-error", {
            cameraError: "not-found"
          });
        } else {
          if (error.name === "NotReadableError" || error.name === "TrackStartError") {
            showErrorToast(t(_temp3));
            trackAction("id-doc:camera-error", {
              cameraError: "already-in-use"
            });
          } else {
            if (error.name === "OverconstrainedError" || error.name === "ConstraintNotSatisfiedError") {
              showErrorToast(t(_temp4));
              trackAction("id-doc:camera-error", {
                cameraError: "constraint"
              });
            } else {
              if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                missingPermissionsSheet.show({});
                trackAction("id-doc:camera-error", {
                  cameraError: "permission-denied"
                });
              } else {
                showErrorToast(t(_temp5));
                trackAction("id-doc:camera-error", {
                  cameraError: "other-error"
                });
              }
            }
          }
        }
      }
      const isUserResolvable = ["NotAllowedError", "PermissionDeniedError", "NotFoundError", "DevicesNotFoundError", "NotReadableError", "TrackStartError"].includes(error.name);
      if (isUserResolvable) {
        Logger.warn(`Camera error: ${err}`, {
          location: "camera"
        });
      } else {
        Logger.error(`Camera error: ${err}`, {
          location: "camera"
        });
      }
    };
    $[3] = missingPermissionsSheet;
    $[4] = showErrorToast;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useHandleCameraError;
function _temp($) {
  return $["undefined-navigator"];
}
function _temp2($_0) {
  return $_0["not-found"];
}
function _temp3($_1) {
  return $_1["already-in-use"];
}
function _temp4($_2) {
  return $_2.constraint;
}
function _temp5($_3) {
  return $_3["other-error"];
}